// Google tag manager config

export const GTM = {
  ID: "GTM-M6SCDWV2", // TODO: 必要に応じて環境変数に移動できます
  CONTAINER_URL: "https://www.googletagmanager.com/gtm.js",
  IFRAME_URL: "https://www.googletagmanager.com/ns.html",
} as const;
